<template>
  <div class="ev-digital-event-room ev-digital-event-modal-window users-mw ev-video-call-settings-modal">
    <div class="header">
      <div class="title">
        <i aria-hidden="true" class="ar-icon icon-cog-solid" style="font-size: 120%;"></i>
        Audio & Video settings
      </div>
    </div>
    <div class="body" style="margin: 0 0 50px">
      <div class="content-body">
        <VideoSettingsSection title="Devices">
          <CallSettingsDevices @deviceUpdated="updateSelectedDevice"></CallSettingsDevices>
        </VideoSettingsSection>

        <VideoSettingsSection title="Connectivity test">
          <CallSettingsConnectivityTest></CallSettingsConnectivityTest>
        </VideoSettingsSection>
      </div>
    </div>
    <div class="footer" style="margin-right: 10px; margin-bottom: 5px">
      <button type="button" class="btn btn-primary pull-right" @click="saveChanges">
        Apply
      </button>
      <button type="button" class="btn btn-default pull-right" @click="$emit('close')">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import VideoSettingsSection from "./VideoSettingsSection";
import CallSettingsConnectivityTest from "./CallSettingsConnectivityTest";
import CallSettingsDevices from "./CallSettingsDevices";
import { DEVICE_TYPE } from "../enums";
import { mapActions } from "vuex";
export default {
  name: "VideoSettingsModal",
  components: {
    CallSettingsDevices,
    CallSettingsConnectivityTest,
    VideoSettingsSection
  },
  data() {
    return {
      newVideoDevice: null,
      newAudioDevice: null
    };
  },
  methods: {
    ...mapActions("calls/devices", ["getAvailableDevices"]),
    updateSelectedDevice(event) {
      if (event.type === DEVICE_TYPE.VIDEO) {
        this.newVideoDevice = event.deviceId;
      } else if (event.type === DEVICE_TYPE.AUDIO) {
        this.newAudioDevice = event.deviceId;
      }
    },
    saveChanges() {
      if (this.newVideoDevice) {
        this.$store.commit("calls/devices/setSelectedVideoSource", this.newVideoDevice);
        this.$store.dispatch("calls/devices/updatePublisherSource", {
          publisher: this.$store.state.calls.defaultPublisher,
          deviceType: DEVICE_TYPE.VIDEO,
          source: this.$store.state.calls.devices.selectedVideoSource,
          persist: true
        });
      }
      if (this.newAudioDevice) {
        this.$store.commit("calls/devices/setSelectedAudioSource", this.newAudioDevice);
        this.$store.dispatch("calls/devices/updatePublisherSource", {
          publisher: this.$store.state.calls.defaultPublisher,
          deviceType: DEVICE_TYPE.AUDIO,
          source: this.$store.state.calls.devices.selectedAudioSource,
          persist: true
        });
      }
      this.$emit("close");
    }
  },
  created() {
    this.getAvailableDevices();
  }
};
</script>

<style lang="less">
.ev-video-call-settings-modal {
  min-height: 470px;
  .header {
    min-height: unset !important;
  }
}
</style>
